module.exports = __webpack_public_path__ + "img/logo_ls.74a71d1d.png";